import { useEffect, useRef } from 'react'

import { Post as TPost } from '@tribeplatform/gql-client/types'
import { Post } from '@tribeplatform/react-components'
import { useQueryParam } from '@tribeplatform/react-components/common'
import { HIGHLIGHTED_POST_QUERY_PARAM } from '@tribeplatform/react-components/common/constants'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { scrollToElement } from '@tribeplatform/react-ui-kit/utils'

import { PostActionButtons } from './PostActionButtons.js'

interface Props {
  post: TPost
}

export const PostItem = ({ post }: Props) => {
  const [highlightedPostId] = useQueryParam<string>({
    name: HIGHLIGHTED_POST_QUERY_PARAM,
  })
  const ref = useRef<HTMLDivElement>(null)
  const shouldScroll = highlightedPostId === post.id
  useEffect(() => {
    if (!shouldScroll || !ref?.current) {
      return
    }

    scrollToElement({ elementRef: ref })
  }, [shouldScroll])

  return (
    <Card key={post.id} id={post.id} ref={ref}>
      <Card.Content className="flex flex-col space-y-4">
        <Post post={post} context="moderation" replyBar={false} />
        <PostActionButtons post={post} />
      </Card.Content>
    </Card>
  )
}
